import { byPrefixAndName } from '@awesome.me/kit-5c288c4b3f/icons'
import { FlexContainer } from '@dv01-inc/waterfall-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GatsbyImage } from 'gatsby-plugin-image'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import React, { useState } from 'react'
import { HeroProps } from '../types'
import { Button } from './Button'
import Promo from './Promo'
import { H1, SubH1 } from './Typography'
import { classNames } from '../utils'

export const Hero = ({
  buttonPath,
  buttonShow,
  buttonText,
  clickHandler,
  ctaIcon,
  customClasses,
  imageFile,
  imageTitle,
  newWindow,
  productIcon,
  promoCta,
  promoShow,
  promoTitle,
  promoUrl,
  secondaryButtonShow,
  secondaryButtonText,
  secondaryClickHandler,
  secondaryCtaIcon,
  secondImageFile,
  secondImageTitle,
  smallTitle,
  subTitle,
  subTitleRichText,
  title,
}: HeroProps) => {
  const [isPromoShown, setIsPromoShown] = useState(true)
  function handleCloseClick() {
    setIsPromoShown(false)
  }
  return (
    <section
      className={classNames(
        'relative grid min-h-108 auto-cols-auto auto-rows-auto',
        customClasses
      )}
    >
      <div className="container z-10 col-start-1 row-start-1 mx-auto h-full px-4">
        <div className="grid h-full grid-cols-12 grid-rows-[20px_auto_auto] items-stretch gap-2 md:gap-7">
          <div className="col-span-12 col-start-1 row-start-2 md:col-span-6">
            <H1>
              {smallTitle && (
                <small className="block text-lg font-bold text-primary-500">
                  {productIcon && productIcon === 'recycle' ? (
                    <span className="fa-layers fa-fw mr-m">
                      <FontAwesomeIcon
                        icon={byPrefixAndName.fal[productIcon]}
                        transform="grow-4"
                      />
                      <FontAwesomeIcon
                        icon={byPrefixAndName.fal['signal-good']}
                        transform="shrink-7 right-2 up-2"
                      />
                    </span>
                  ) : (
                    <span className="mr-m">
                      <FontAwesomeIcon
                        icon={byPrefixAndName.fal[productIcon]}
                      />
                    </span>
                  )}
                  {smallTitle}
                </small>
              )}
              {title}
            </H1>
            <div className="mb-14">
              {subTitle && <SubH1>{subTitle}</SubH1>}
              {subTitleRichText && (
                <SubH1>{renderRichText(subTitleRichText)}</SubH1>
              )}
            </div>
            <FlexContainer
              flexDirection="flex-col"
              flexGap="gap-4"
              alignItems="items-start"
            >
              {buttonShow && (
                <Button
                  icon={ctaIcon}
                  to={clickHandler ? null : `${buttonPath}`}
                  onClick={clickHandler}
                  target={newWindow ? '_blank' : '_self'}
                  rel={newWindow ? 'noreferrer noopener' : ''}
                  variant="primary"
                  size="xl"
                >
                  {buttonText}
                </Button>
              )}
              {secondaryButtonShow && (
                <Button
                  icon={secondaryCtaIcon}
                  variant="secondary"
                  size="xl"
                  to={secondaryClickHandler ? null : buttonPath}
                  onClick={secondaryClickHandler}
                  target={newWindow ? '_blank' : '_self'}
                  rel={newWindow ? 'noreferrer noopener' : ''}
                >
                  {secondaryButtonText}
                </Button>
              )}
            </FlexContainer>
          </div>
          {secondImageFile && (
            <GatsbyImage
              className="col-span-12 col-start-1 row-start-3 md:col-span-5 md:col-start-8 md:row-span-3 md:row-start-2"
              loading="eager"
              objectFit="contain"
              image={secondImageFile}
              alt={secondImageTitle}
            />
          )}
          {promoShow && isPromoShown && (
            <Promo
              text={promoTitle}
              url={promoUrl}
              cta={promoCta}
              handleClose={handleCloseClick}
            />
          )}
        </div>
      </div>
      {imageFile && (
        <GatsbyImage
          className="col-start-1 row-start-1"
          loading="eager"
          backgroundColor="#000"
          image={imageFile}
          alt={imageTitle}
        />
      )}
    </section>
  )
}
